// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitDepartureDateLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/SearchUnitDepartureDateLayout/SearchUnitDepartureDateLayout.scss
 ** module id = 961
 ** module chunks = 1
 **/